export const FETCH_AUDIT_DATA = 'audit/FETCH_AUDIT_DATA';
